import { IDiff } from '@Shared/bulk_upload';
import { IAddTransactionDiff } from '@Shared/card_statement_upload';

export const RECEIVE_BULK_UPLOAD_DIFFS = 'RECEIVE_TEAM_BULK_UPLOAD_DIFFS';
export const RECEIVE_CARD_STATEMENT_UPLOAD_DIFFS = 'RECEIVE_CARD_STATEMENT_UPLOAD_DIFFS';
export const REVIEW_CARD_HOLDERS = 'REVIEW_CARD_HOLDERS';
export const REVIEW_DUPLICATES = 'REVIEW_DUPLICATES';
export const TOGGLE_CHANGE_TO_APPLY = 'TOGGLE_CHANGE_TO_APPLY';
export const TOGGLE_VIEWING_ERROR_DETAILS = 'TOGGLE_VIEWING_ERROR_DETAILS';
export const RECORD_PROCESSING_FAILURE = 'RECORD_PROCESSING_FAILURE';
export const CLEAR_PROCESSING_FAILURE = 'CLEAR_PROCESSING_FAILURE';
export const TOGGLE_CONFIRMING_CHANGES = 'TOGGLE_CONFIRMING_CHANGES';
export const SET_PREVIEW_TAB = 'SET_PREVIEW_TAB';
export const SAVE_CSV_DATA = 'SAVE_CSV_DATA';
export const SET_DIFFS_TO_APPLY = 'SET_DIFFS_TO_APPLY'; // a little odd, we'll use this to skip the other diffs

export const UPDATE_ADD_CARD_DIFF_CARD_HOLDER = 'UPDATE_ADD_CARD_DIFF_CARD_HOLDER';

export class ClearProcessingFailure {
  readonly type = CLEAR_PROCESSING_FAILURE;
}

export class ReceiveBulkUploadDiffs {
  readonly type = RECEIVE_BULK_UPLOAD_DIFFS;
  constructor(public diffs: IDiff[]) {}
}

export class ReceiveCardStatementUploadDiffs {
  readonly type = RECEIVE_CARD_STATEMENT_UPLOAD_DIFFS;
  constructor(public diffs: IDiff[]) {}
}

export class ReviewCardHolders {
  readonly type = REVIEW_CARD_HOLDERS;
  constructor(public reviewed: boolean) {}
}

export class ReviewDuplicates {
  readonly type = REVIEW_DUPLICATES;
  constructor(public reviewed: boolean) {}
}

export class UpdateAddCardDiffCardHolder {
  readonly type = UPDATE_ADD_CARD_DIFF_CARD_HOLDER;
  constructor(public temporaryAccountId: string, public userId: string) {}
}

export class SetDiffsToApply {
  readonly type = SET_DIFFS_TO_APPLY;
  constructor(public diffs: IAddTransactionDiff[]) {}
}

export class RecordProcessingFailure {
  readonly type = RECORD_PROCESSING_FAILURE;
  constructor(public error: string, public diffs: IDiff[]) {}
}

export class SaveCsvData {
  readonly type = SAVE_CSV_DATA;
  constructor(public data: string, public fileType: string) {}
}

export class SetPreviewTab {
  readonly type = SET_PREVIEW_TAB;
  constructor(public change: string) {}
}

export class ToggleChangeToApply {
  readonly type = TOGGLE_CHANGE_TO_APPLY;
  constructor(public change: Record<string, boolean>) {}
}

export class ToggleConfirmingChanges {
  readonly type = TOGGLE_CONFIRMING_CHANGES;
}

export class ToggleViewingErrorDetails {
  readonly type = TOGGLE_VIEWING_ERROR_DETAILS;
}

export type CardStatementUploadAction =
  | ReceiveCardStatementUploadDiffs
  | UpdateAddCardDiffCardHolder
  | ReviewCardHolders
  | ReviewDuplicates
  | SetDiffsToApply;

export type BulkUploadAction =
  | ClearProcessingFailure
  | ReceiveBulkUploadDiffs
  | RecordProcessingFailure
  | SaveCsvData
  | SetPreviewTab
  | ToggleChangeToApply
  | ToggleConfirmingChanges
  | ToggleViewingErrorDetails;
